module.exports = __webpack_public_path__ + "static/coindesk-logo-7f988dc7db7f60ca2d2e8d3536f4f53b.png";